import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from './../services/login.service';

@Injectable({
  providedIn: 'root'
})
export class ClienteActivateGuard implements CanActivate {

  private user: any

  constructor(private loginService: LoginService, private router: Router) {
    this.user = loginService.getUserData()
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): any {
      if(this.user.rol === 'superuser') return true
      else if(!this.user.cliente){
        this.loginService.removeUserStorage()
        this.router.navigate(['']);
        return false
      }
    return true;
  }
  
}
